module.exports = __webpack_public_path__ + "img/PAD.53abd14a.svg";